
enum QuizType {
    Generic = "Generic",
    MBTI = "MBTI",
    StarSign = "StarSign",
    LoveLanguage = "LoveLanguage",
}

export { QuizType };